export const MultipleCanesBanner = () => {
  return (
    <div className="mb-1 flex w-full items-center gap-2 rounded border border-blue-200 bg-blue-50 px-3 py-1.5">
      <i className="pi pi-exclamation-circle text-blue-600" />
      <span className="text-sm text-blue-900">
        Some embryos have multiple canes or freeze dates in mating
      </span>
    </div>
  );
};
